import type { WorkflowDetailPresentation } from '../../../contracts/work-host-shapes';
import type { RecordedWorkflowMetadata } from '../../../data/projects/lib/read-rpa-skill-workflow';
import { createRecordedWorkflowMetadataReader } from '../../../data/projects/lib/read-rpa-skill-workflow';
import { getWorkHostPort } from '../../work-home/work-home-ports';

export type RpaSkillWorkflowDisplay =
  RecordedWorkflowMetadata<WorkflowDetailPresentation>;

export const readRpaSkillWorkflowFromMetadata = createRecordedWorkflowMetadataReader(
  (payload, untitledFallback): WorkflowDetailPresentation => {
    const desktop = getWorkHostPort('desktop');
    return desktop.deriveWorkflowDetailPresentation({
      bridgeAvailable: true,
      isLoading: false,
      isError: false,
      parseResult: desktop.parseWorkflow(desktop.coerceWorkflowWirePayload(payload)),
      untitledFallback,
    }) as WorkflowDetailPresentation;
  }
);
